import React, { useState, useRef } from "react";
import styles from "./index.modules.less";
import CardInfo from "../../components/CardInfo";
import { cj } from "../../utils/cls";
import { useDispatch, useSelector } from "react-redux";
import classnames from "classnames";
import { useNavigate } from "react-router-dom";
import { message } from "../../components/Message";
import { whiteList } from "../../utils/constant";

const tableItem = ({ data: item, index, tabkey }) => {
  const timerRef = useRef(null);
  const [modelShow, setModelShow] = useState({ type: false });
  const { config } = useSelector((state) => state);
  const { user } = useSelector((state) => state);
  const navigate = useNavigate();

  const configItem = config?.app_status?.find(
    (config) => config.id == item.app_status_id
  );
  const configType = config?.soft_cate?.find(
    (config) => config.id == item.app_cate_d
  );
  console.log("tabkey is", tabkey);
  const showCard = (item, e) => {
    timerRef.current && clearTimeout(timerRef.current);
    const x = e.target.offsetLeft + 24 - 104;
    const y = e.target.offsetTop + 20;
    timerRef.current = setTimeout(() => {
      setModelShow({
        type: true,
        x,
        y,
        record: item,
      });
    }, 300);
  };

  const hideCard = () => {
    timerRef.current && clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setModelShow({
        type: false,
        x: 0,
        y: 0,
        record: null,
      });
    }, 300);
  };
  return (
    <>
      <div key={item.app_cate_id} className={cj(styles.bg, styles.l_item)}>
        <div className={styles.l_name}>
          {item.logo_url ? <img width={32} src={item.logo_url} /> : <img width={32} src="https://p3.ssl.qhimg.com/t01ea0f774a67ee6d1a.png" />}
          <span>{item.app_name}</span>
          {item.channel == 0 ? <i>测试</i> : ""}
        </div>
        <div className={styles.l_type}>
          {configType?.name ? configType?.name : "----"}
        </div>
        <div className={styles.l_version}> 版本：{item.app_version}</div>
        <div className={styles.l_time}>{item.ctime}</div>
        <div
          style={{
            overflow: 'visible'
          }}
          className={classnames(styles.l_state, {
            [styles[`config_${configItem?.id}`]]: !!configItem?.id,
          })}
        >
          <div className={styles.audit}>{configItem?.name}</div>
          {item.app_status_id == 3 ? (
            <div className={styles.auditBox}>
              <img
                className={styles.audit_failed}
                src="https://p1.ssl.qhimg.com/t01b81a8f8144c46b18.png"
              />
              <strong className={styles.reason}>
                {item.offline_reason}
                {/* {item.audit_failed_reason} */}
              </strong>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className={styles.l_type}>{item.remark?item.remark:"-"}</div>
        <div
          onClick={() => {
            // if (item.channel == 0 ) {
            //   return
            // }
            // navigate(`/view/detail/${item.id}`)

              navigate(`/view/detail/${item.id}`)
            
            
          }}
          className={classnames(styles.l_btn)}
        >
          管理
        </div>
      </div>
      {modelShow.type ? (
        <CardInfo
          style={{
            left: modelShow.x,
            top: modelShow.y,
          }}
          pRef={timerRef}
          data={modelShow.record}
          hideCard={hideCard}
          showCard={showCard}
        ></CardInfo>
      ) : null}
    </>
  );
};

export default tableItem;
